export function getSectionSingletonDoubletonInfo({
  sectionId,
  sections,
  subsections,
  separateICRCodes,
}) {
  if (!sectionId) return { isSingleton: false, isDoubleton: false };

  const sectionInfo = sections.find((section) => section.section_id === sectionId);
  if (!sectionInfo) return { isSingleton: false, isDoubleton: false };

  const sectionSubsections = "subsections" in sectionInfo ? sectionInfo.subsections : [];
  const relevantSections = [sectionId, ...sectionSubsections];

  let isSingleton = false;
  let isDoubleton = false;

  relevantSections.forEach((tempSectionId) => {
    const tempSectionInfo = sections.find((tempSection) => tempSection.section_id === tempSectionId);
    if (!tempSectionInfo) return;

    const tempSectionCourseId = tempSectionInfo.course_id;
    const sectionsOfCourseData = sections
      .filter(
        (section) =>
          section.course_id === tempSectionCourseId &&
          "course_periods" in section &&
          section.course_periods.length > 0 &&
          section.is_lab === "0"
      )
      .reduce(
        (results, tempSection) => {
          const currentTempSectionId = tempSection.section_id;
          if (results.loggedSections.includes(currentTempSectionId)) return results;
          results.loggedSections.push(currentTempSectionId);

          const currentTempSectionCourseId = tempSection.course_id;
          const currentTempSectionSpanId = tempSection.span_id;
          const currentTempSectionIsInclusion = tempSection.is_inclusion;
          const tempSubsectionIndex = subsections.findIndex(
            (tempSubsection) => tempSubsection.subsection_id === currentTempSectionId
          );

          let tempIsPlaceholderInclusion = false;
          if (separateICRCodes === "0" && currentTempSectionIsInclusion && tempSubsectionIndex !== -1) {
            const tempSubsectionInfo = subsections[tempSubsectionIndex];
            const tempMainSectionId = tempSubsectionInfo.section_id;
            const tempMainSectionInfo = sections.find(
              (section) => section.section_id === tempMainSectionId
            );
            const tempMainCourseId = tempMainSectionInfo ? tempMainSectionInfo.course_id : null;

            if (currentTempSectionCourseId === tempMainCourseId) {
              tempIsPlaceholderInclusion = true;
            }
          }

          if (tempIsPlaceholderInclusion) return results;

          results.sectionsOfCourse.push(currentTempSectionId);

          if (currentTempSectionSpanId) {
            sections
              .filter((section) => section.span_id === currentTempSectionSpanId)
              .forEach((spanSection) => {
                const spanSectionId = spanSection.section_id;
                if (!results.loggedSections.includes(spanSectionId)) {
                  results.loggedSections.push(spanSectionId);
                }
              });
          }

          return results;
        },
        { sectionsOfCourse: [], loggedSections: [] }
      );

    const courseIsSingleton = sectionsOfCourseData.sectionsOfCourse.length === 1;
    const courseIsDoubleton = sectionsOfCourseData.sectionsOfCourse.length === 2;

    if (courseIsSingleton) isSingleton = true;
    if (courseIsDoubleton) isDoubleton = true;
  });

  return { isSingleton: isSingleton, isDoubleton: isDoubleton };
}

export function buildSectionSingletonDoubletonMap({
  sections,
  subsections,
  separateICRCodes,
}) {
  const subsectionToMainMap = subsections.reduce((map, subsection) => {
    map[subsection.subsection_id] = subsection.section_id;
    return map;
  }, {});

  const cache = {};
  const resultMap = {};

  sections.forEach((section) => {
    const sectionId = section.section_id;
    const mainSectionId = subsectionToMainMap[sectionId] || sectionId;

    if (!cache[mainSectionId]) {
      cache[mainSectionId] = getSectionSingletonDoubletonInfo({
        sectionId: mainSectionId,
        sections,
        subsections,
        separateICRCodes,
      });
    }

    resultMap[sectionId] = cache[mainSectionId];
  });

  return resultMap;
}
